


















































import { Component, Watch, Prop, Emit } from 'vue-property-decorator';
import Vue from 'vue';
import MenuItem from '@/components/menu/menu-item.vue';
import BookmarkAdd from '@/components/bookmark/bookmark-add.vue';

@Component({
  components: {
    MenuItem,
    BookmarkAdd
  }
})
export default class MainMenuReportTabsMobileItem extends Vue {
  @Prop() 
  item: any;

  @Prop({ default: 'tab' }) 
  type: 'dropdown' | 'tab';

  @Prop() 
  bookmarkIndexes: any[];

  @Prop({ default: null })
  decorativeDropdown: boolean;

  get isDropdown() {
    return this.type === 'dropdown';
  }

  get isSettings() {
    return this.item.key === 'settings';
  }

  get title() {
    return this.isDropdown
      ? this.item.name
      : this.item.title;
  }

  get hasDropdownIcon() {
    return this.isDropdown || null;
  }

  get hasClose() {
    return !this.isDropdown && this.item.close;
  }

  get hasShare() {
    return this.hasClose && !this.isSettings;
  }

  @Emit('click')
  onClick(event?: any) {} 

  @Emit('close')
  onClose(event?: any) {} 

  @Emit('share')
  onShare(event?: any) {} 
}
